import { render, staticRenderFns } from "./ResultsCarousel.vue?vue&type=template&id=f3702cba&scoped=true&"
import script from "./ResultsCarousel.vue?vue&type=script&lang=js&"
export * from "./ResultsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ResultsCarousel.vue?vue&type=style&index=0&id=f3702cba&prod&lang=css&"
import style1 from "./ResultsCarousel.vue?vue&type=style&index=1&id=f3702cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3702cba",
  null
  
)

export default component.exports